var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-autocomplete',_vm._g(_vm._b({attrs:{"id":"google-search","items":_vm.results,"item-text":"description","return-object":""},on:{"keydown":_vm.onSearch,"change":_vm.onSelect},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},'custom-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }